var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-border text-brand",staticStyle:{"font-size":"10px"},style:({ width: _vm.Size + 'px', height: _vm.Size + 'px' }),attrs:{"role":"status"}})
}
var staticRenderFns = []

export { render, staticRenderFns }